'use strict';

var scrollBarUtil = require('../utils/scrollBarUtil');

/**
 * Resets all custom feedback messages and dropdown section styles to their default state.
 *
 * This function hides elements used for displaying custom validation errors
 * (such as invalid or missing feedback) and removes the border highlight
 * from the dropdown section if it was previously applied.
 *
 * @returns {void} - Does not return a value.
 */
function resetCustomFeedback() {
    $('.custom-invalid-feedback, .custom-missing-feedback').addClass('d-none');
    $('.phone-input-section .custom-drop-down-section').removeClass('is-invalid');
}

/**
 * Validates the input value based on the specified type.
 *
 * @param {string} value - The input value to validate.
 * @param {string} type - The type of the input (e.g., 'text', 'email', 'tel').
 * @returns {boolean} - True if the input is valid, false otherwise.
 */
function validateInput(value, type) {
    if (type === 'text') {
        return value.trim() !== '';
    }

    if (type === 'email') {
        var emailPattern = /^[\w.%+ -]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        return emailPattern.test(value);
    }

    if (type === 'tel') {
        var maxLength = $('#reqphone').attr('maxlength');

        var phonePattern = new RegExp('^\\d{' + maxLength + '}$');
        var isAllZeros = value === '0'.repeat(maxLength);
        var isValid = phonePattern.test(value) && !isAllZeros;

        if (isValid) {
            resetCustomFeedback();
        }

        return isValid;
    }
    return false;
}

/**
 * Check a single input element and clear validation UI if valid.
 *
 * @param {jQuery} $this - jQuery-wrapped input element to validate
 * @returns {void}
 */
function inputCheck($this) {
    var valid = validateInput($this.val(), $this.attr('type'));
    if (valid) {
        $this.removeClass('is-invalid');
        $('.custom-feedback').removeClass('d-block');
    }
}

/**
 * Resets the "customer title" selection within the Request Price name section UI.
 *
 * Locates the `.request-price-fn-group` container and its custom dropdown elements,
 * then selects an option matching the provided `customerTitle` (by `data-title` or
 * trimmed text). If no title is provided or no match is found, it falls back to the
 * first available option. Updates:
 * - the selected option state (`.selected` class),
 * - the visible label (`.selected-value`),
 * - the hidden input value (`input[name="customerTitle"]`, set from option `data-code`).
 *
 * If required DOM elements are missing, the function exits without changes.
 *
 * @function resetCustomerTitle
 * @param {string} [customerTitle=''] - The title to select (matched against option `data-title` or text).
 * @returns {void}
 */
function resetCustomerTitle(customerTitle) {
    var requestPriceCustomerTitle = customerTitle || '';
    var $nameSection = $('.request-price-fn-group');
    if (!$nameSection.length) return;

    var $dropdown = $nameSection.find('.custom-drop-down-section');
    if (!$dropdown.length) return;

    var $options = $dropdown.find('.custom-option-value');
    if (!$options.length) return;

    var $display = $dropdown.find('.selected-value').first();
    var $hiddenInput = $nameSection.find('input[name="customerTitle"]');

    var $targetOption;

    // If customerTitle is passed → select matching option
    if (requestPriceCustomerTitle) {
        $targetOption = $options.filter(function () {
            var title = $(this).attr('data-title') || $(this).text().trim();
            return title === requestPriceCustomerTitle;
        }).first();
    }

    // If NOT passed or not found → select FIRST <li>
    if (!$targetOption || !$targetOption.length) {
        $targetOption = $options.first();
    }

    var nextTitle = $targetOption.attr('data-title') || $targetOption.text().trim();
    var nextCode = $targetOption.attr('data-code');

    // Reset selection
    $options.removeClass('selected');
    $targetOption.addClass('selected');

    // Update visible text
    if ($display.length) {
        $display.text(nextTitle);
    }

    // Update hidden field
    if ($hiddenInput.length && nextCode) {
        $hiddenInput.val(nextCode);
    }

    if (customerTitle) {
        $dropdown.addClass('non-editable');
    }
}

/**
 * Resets the phone input UI's selected country code to a desired default.
 *
 * If a `countryCode` is provided, the function attempts to select the matching
 * option within `.phone-input-section` by finding a `.custom-option-value` with
 * `data-id` equal to the provided value. If no `countryCode` is provided, it
 * selects the first available `.custom-option-value` in the list.
 *
 * When a default option is found, this updates the displayed selected value,
 * clears any previous selection styling, applies selection classes to the
 * chosen option/container, and hides the dropdown option lists.
 *
 * @param {string} [countryCode] - Country calling code identifier to select (matches `data-id`).
 * @returns {void}
 */
function resetCountryCodeToDefault(countryCode) {
    var requestPriceCountryCode = countryCode || '';
    var $container = $('.phone-input-section');
    var $defaultOption;

    // If countryCode is passed → use it
    if (requestPriceCountryCode) {
        $defaultOption = $container
            .find('.custom-option-value[data-id="' + requestPriceCountryCode + '"]')
            .first();
    } else { // Else → pick FIRST option from the list
        $defaultOption = $container.find('.custom-option-value').first();
    }

    if ($defaultOption.length) {
        var defaultCode = $defaultOption.data('id');

        // Update display
        $container.find('.selected-value, .country-selected-value')
            .text(defaultCode)
            .addClass('active');

        // Reset selected states
        $container.find('.custom-option-value, .country-option-item')
            .removeClass('selected');

        $defaultOption.addClass('selected');
        $container.addClass('selected');

        // Hide dropdown
        $container.find('.custom-option-values, .country-dropdown-options').hide();
    }

    if (countryCode) {
        $container.find('.custom-drop-down-section').addClass('non-editable');
    }
}

$(document).ready(function () {
    $('body').on('click', '#price-request-form .custom-drop-down-section .title-code-option', function () {
        var code = $(this).attr('data-code');
        var value = $(this).attr('data-title');
        $('#price-request-form .title-code').val(code);
        $('#price-request-form .title-code').attr('data-customertitle', value);
    });

    $('body').on('click', '.plp-slick-carousel .request-price-btn, .request-btn-wrapper .request-price-btn, .sticky-row .request-price-btn', function (e) {
        e.preventDefault();
        var userAuthenticated = $(this).siblings('input[name="isAuthenticated"]').val();

        $('body').addClass('back-ground-scroll');
        scrollBarUtil.applyScrollbarPadding();
        $('body').addClass('overflow-hidden');

        if (userAuthenticated === 'true') {
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                success: function (data) {
                    if (data && data.customer) {
                        var customer = data.customer;
                        if (customer.customerTitle) resetCustomerTitle(customer.customerTitle);
                        if (customer.firstName) $('#price-request-modal form .reqFname').val(customer.firstName).trigger('input').prop('readonly', true);
                        if (customer.lastName) $('#price-request-modal form .reqLname').val(customer.lastName).trigger('input').prop('readonly', true);
                        if (customer.customerEmail) $('#price-request-modal form .reqEmail').val(customer.customerEmail).trigger('input').prop('readonly', true);
                        if (customer.mobileDialingCode) resetCountryCodeToDefault(customer.mobileDialingCode);
                        if (customer.customerPhone) $('#price-request-modal form .reqPhone').val(customer.customerPhone).trigger('input').prop('readonly', true);
                    }
                }
            });
            $('#price-request-modal .request-price-product-id').val($(this).closest('.request-btn-wrapper').find('.product-id').val());
            $('#price-request-modal').modal('show');
        } else {
            $('#price-request-modal').find('form input').val('');
            $('.form-group .placeholder').removeClass('d-none');
            $('.custom-feedback').removeClass('d-block');
            $('#price-request-modal').modal('show');
            $('#price-request-modal .request-price-product-id').val($(this).closest('.request-btn-wrapper').find('.product-id').val());
        }

        var phoneLength = $('#price-request-form .phone-input-field').find('.custom-option-value.custom-option-login.selected').data('phonelength');
        $('#price-request-form .reqPhone').attr('maxlength', phoneLength);
    });

    // --- Updated phone input rule ---
    $('input.reqPhone').on('input', function () {
        var $this = $(this);
        var $formGroup = $this.closest('.form-group');
        var $invalidFeedback = $formGroup.find('.custom-invalid-feedback');
        var $missingFeedback = $formGroup.find('.custom-missing-feedback');
        var $dropdown = $formGroup.find('.custom-drop-down-section');
        var phoneLength = $(this).attr('maxlength');
        var selectedCode = $('.phone-input-section #select-country-code').text().trim();
        var val = $this.val().replace(/\D/g, '');

        // Reset errors first
        $this.removeClass('is-invalid');
        $invalidFeedback.addClass('d-none');
        $missingFeedback.addClass('d-none');
        $dropdown.removeClass('is-invalid');

        // +91 → block starting digits 0–5
        if (selectedCode === '+91' && val.length === 1 && /^[0-5]$/.test(val)) {
            $this.val('');
            $this.addClass('is-invalid');
            $invalidFeedback.removeClass('d-none');
            $dropdown.addClass('is-invalid');
            return;
        }

        // Limit to phoneLength digits
        val = val.substring(0, phoneLength);
        $this.val(val);

        inputCheck($this);

        if ($this.val().trim() === '') {
            $this.addClass('is-invalid');
            $('.phone-input-section').siblings('.custom-missing-feedback').removeClass('d-none');
            $('.phone-input-field').addClass('is-invalid');
        }
    });

    $('input.reqPhone').on('blur', function () {
        var $this = $(this);
        var $formGroup = $this.closest('.form-group');
        var $invalidFeedback = $formGroup.find('.custom-invalid-feedback');
        var $missingFeedback = $formGroup.find('.custom-missing-feedback');
        var $dropdown = $formGroup.find('.custom-drop-down-section');

        var selectedCode = $('#select-country-code').text().trim();
        var phoneLength = $(this).attr('maxlength');
        var val = $this.val().trim();

        // Only for +91
        if (selectedCode === '+91') {
            if (val.length > 0 && val.length < phoneLength) {
                $this.addClass('is-invalid');
                $missingFeedback.removeClass('d-none');
                $invalidFeedback.addClass('d-none');
                $dropdown.addClass('is-invalid');
            }
        }
    });

    $('input.reqFname, input.reqLname').on('input', function () {
        if ($(this).val().trim() === '') {
            $(this).val('');
            var missingError = $(this).data('missing-error');
            if ($(this).hasClass('reqFname')) {
                $(this).addClass('is-invalid');
                $('.req-fn-invalid-feedback').text(missingError);
                $('.requestprice-customer-title-wrapper .custom-drop-down-section').addClass('is-invalid');
            } else if ($(this).hasClass('reqLname')) {
                $(this).addClass('is-invalid');
                $('#reqlastName').siblings('.invalid-feedback').text(missingError);
            }
            return;
        }

        $(this).val(this.value.replace(/[^a-zA-Z\s]/g, ''));
        var valid = validateInput($(this).val(), $(this).attr('type'));
        if (valid) $(this).removeClass('is-invalid');

        if (valid && $(this).hasClass('reqFname')) {
            $('.requestprice-customer-title-wrapper .custom-drop-down-section').removeClass('is-invalid');
        }
    });

    $('input.reqEmail').on('input', function () {
        $(this).val(this.value.replace(/\s/g, ''));
        inputCheck($(this));

        if ($(this).val().trim() === '') {
            $(this).addClass('is-invalid');
            var missingError = $(this).data('missing-error');
            $('#form-email-error').text(missingError).removeClass('d-none');
            $('#form-email-error').siblings('.custom-feedback').removeClass('d-block').addClass('d-none');
        } else {
            $(this).removeClass('is-invalid');
            $('#form-email-error').text('').removeClass('d-none');
            $('#form-email-error').siblings('.custom-feedback').removeClass('d-block').addClass('d-none');
        }
    });

    $('body').on('hidden.bs.modal', '#price-request-modal', function () {
        var $priceRequestModal = $('#price-request-modal');
        $priceRequestModal.find('input')
            .val('')
            .removeClass('is-invalid');
        $('body').removeClass('back-ground-scroll');
        scrollBarUtil.applyScrollbarPadding();
        $('body').removeClass('overflow-hidden');
        resetCustomFeedback();
        resetCustomerTitle();
        $('.requestprice-customer-title-wrapper .custom-drop-down-section').removeClass('is-invalid');
        resetCountryCodeToDefault();
    });

    var form = $('#price-request-modal form');
    form.on('submit', function (e) {
        e.preventDefault();
        var $formInputs = $('#price-request-modal').find('input').not('[type="hidden"]');
        var error = false;

        $formInputs.each(function () {
            var isValid = validateInput($(this).val(), $(this).attr('type'));
            if (!isValid) {
                error = true;
            }
        });

        var pid = $('.request-price-product-id').val();
        var selectedCode = $('#login-modal-form #select-country-code').text().trim();
        var Cleardata = ($('#price-request-form .title-code').data('customertitle') || $('.requestprice-customer-title-wrapper .selected-value').text()).replace(selectedCode, '').trim();
        var formData = form.serialize() + '&pid=' + encodeURIComponent(pid) + '&customerTitle=' + encodeURIComponent(Cleardata) + '&countryCode=' + encodeURIComponent(selectedCode);
        if (!error) {
            var url = $('.validation-url').val();
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'JSON',
                data: formData,
                success: function (data) {
                    if (data.success) {
                        $('#price-request-modal').modal('hide');
                        $('#request-success-modal').modal('show');
                        $formInputs.each(function () {
                            $(this).val('');
                        });
                        resetCustomerTitle();
                    } else {
                        $('#price-request-modal').modal('hide');
                        $('#request-exist-modal').modal('show');
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                    $('#price-request-modal').modal('hide');
                }
            });
        }
    });

    $('body').on('click', '.price-request-submit', function () {
        /**
         * Toggle feedback visibility for an input.
         * @param {jQuery} $input - input jQuery element
         * @param {boolean} isValid - validation result
         * @returns {void}
         */
        function toggleFeedback($input, isValid) {
            $input.siblings('.invalid-feedback').toggleClass('d-none', !isValid);
            $input.siblings('.custom-feedback').toggleClass('d-block', !isValid);
            $input.toggleClass('is-invalid', !isValid);
        }

        var $form = $(this).closest('form');

        // --- Phone validation ---
        var $phoneInput = $form.find('input.reqPhone');
        let maxLength = $('#price-request-form').find('#reqphone').attr('maxlength');
        let regex = new RegExp('^[0-9]{' + maxLength + '}$');

        var phoneVal = $phoneInput.val().trim();
        var $invalidFeedback = $phoneInput.closest('.form-group').find('.custom-invalid-feedback');
        var $missingFeedback = $phoneInput.closest('.form-group').find('.custom-missing-feedback');

        if ($('#reqfirstName').val().trim() === '') {
            $('.requestprice-customer-title-wrapper .custom-drop-down-section').addClass('is-invalid');
        }

        if (phoneVal === '') {
            // Empty input → show missing-feedback (missing message)
            $phoneInput.addClass('is-invalid');
            $invalidFeedback.addClass('d-none');
            $missingFeedback.removeClass('d-none');
            $('.phone-input-section .custom-drop-down-section').addClass('is-invalid');
        } else if (!regex.test(phoneVal) || phoneVal === '0'.repeat(maxLength)) {
            // Invalid input → show invalid-feedback (parse message)
            $phoneInput.addClass('is-invalid');
            $missingFeedback.addClass('d-none');
            $invalidFeedback.removeClass('d-none');
            $('.phone-input-section .custom-drop-down-section').addClass('is-invalid');
        } else {
            // Valid input → hide both
            $phoneInput.removeClass('is-invalid');
            resetCustomFeedback();
        }

        // Email validation
        var $emailInput = $form.find('input.reqEmail');
        var emailVal = $emailInput.val().trim();
        var emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        var isEmailValid = (emailVal === '' || emailPattern.test(emailVal));
        toggleFeedback($emailInput, isEmailValid);
    });

    // --- Clear phone input when country code changes ---
    $('body').on('click', '.phone-input-section .custom-option-value.custom-option-login', function () {
        var selectedText = $(this).text().trim();
        var $phoneInput = $('#reqphone');
        $('#select-country-code').text(selectedText); // Update display
        $phoneInput.val(''); // clear phone number
        $phoneInput.siblings('.placeholder').removeClass('d-none');
        $('.phone-input-section').siblings('.custom-invalid-feedback, .custom-missing-feedback').addClass('d-none');
        $('.phone-input-field').removeClass('is-invalid');
        $phoneInput.removeClass('is-invalid');
        var phoneLength = $(this).data('phonelength');
        $('#price-request-form').find('#reqphone').attr('maxlength', phoneLength);
    });
});
